import { Button } from '../button';
import { ComponentPropsWithoutRef, ReactNode } from 'react';

interface PrimaryButtonProps extends ComponentPropsWithoutRef<typeof Button> {
    children: ReactNode;
    className?: string;
}

export function SecondaryButton({ children, className, ...props }: PrimaryButtonProps) {
    return (
        <Button
            className={`
              bg-primery-blue-50 h-auto text-primery-blue-500 text-xs font-medium rounded-sm px-3 py-2
              hover:bg-primery-blue-100
              focus:bg-secondary-blue-100 focus:outline-none focus:ring-2 focus:ring-secondary-blue-100 focus:ring-offset-2
              disabled:bg-secondary-blue-50 disabled:text-primery-blue-200 disabled:opacity-50
              md:rounded-md md:text-sm
              lg:px-4 lg:text-base lg:leading-5
              xl:px-6 xl:py-3
        ${className || ''}
      `}
            {...props}
        >
            {children}
        </Button>
    );
}
